module.exports = __webpack_public_path__ + "img/oldLogo.681c4bf1.jpg";